export default __webpack_public_path__ + "static/media/upload_icon.e21839a9.svg";